import type { CoinInfo, Campaign, PlayerPrize } from '@/types/types';
import { ref } from 'vue';

export const coinInfo = ref<CoinInfo | null>(null);
export const campaign = ref<Campaign>();

export const totalPrizes = ref(0);
export const maxWin = ref(0);
export const playerWin = ref<PlayerPrize | null>(null);
